import { Box, Button, Chip, Stack, Typography } from "@mui/material";

const TRIAL_BOOKING_URL = "https://book.stripe.com/28o3fFfSQ5Vu03S8ww";

export const Hero = () => (
  <Box
    id="home"
    sx={{
      position: "relative",
      width: "100%",
      height: "100vh",
      minHeight: 560,
      overflow: "hidden",
    }}
  >
    {/* Background Video */}
    <video
      autoPlay
      loop
      muted
      playsInline
      aria-hidden="true"
      style={{
        position: "absolute",
        top: 0,
        left: 0,
        width: "100%",
        height: "100%",
        objectFit: "cover",
      }}
    >
      <source src="./coverVideo2.mp4" type="video/mp4" />
    </video>

    {/* Dark gradient overlay */}
    <Box
      sx={{
        position: "absolute",
        inset: 0,
        background:
          "linear-gradient(to bottom, rgba(0,0,0,0.55) 0%, rgba(0,0,0,0.35) 60%, rgba(0,0,0,0.6) 100%)",
      }}
    />

    {/* Content */}
    <Box
      sx={{
        position: "relative",
        zIndex: 1,
        height: "100%",
        display: "flex",
        flexDirection: "column",
        justifyContent: "center",
        alignItems: "center",
        textAlign: "center",
        px: { xs: 3, sm: 6 },
        pt: 8,
      }}
    >
      <Chip
        label="Taking a break this season ✦ Back in 2027"
        size="small"
        sx={{
          bgcolor: "teal.main",
          color: "common.white",
          fontWeight: 700,
          letterSpacing: 0.5,
          fontSize: { xs: 11, sm: 13 },
          mb: 3,
          px: 1,
        }}
      />

      <Typography
        component="h1"
        sx={{
          fontWeight: 900,
          color: "common.white",
          fontSize: { xs: "2.2rem", sm: "3.2rem", md: "4rem" },
          lineHeight: 1.1,
          maxWidth: 780,
          mb: 3,
          textShadow: "0 2px 12px rgba(0,0,0,0.4)",
        }}
      >
        Copenhagen's most energetic fitness experience
      </Typography>

      <Typography
        variant="h6"
        sx={{
          color: "common.white",
          opacity: 0.9,
          fontWeight: 400,
          lineHeight: 1.7,
          maxWidth: 600,
          mb: 5,
          fontSize: { xs: "1rem", sm: "1.2rem" },
        }}
      >
        High-intensity Kangoo Jumps classes that combine cardio, expressive
        movement, and a tight-knit community - where fitness feels like pure joy.
      </Typography>

      <Stack
        direction={{ xs: "column", sm: "row" }}
        spacing={2}
        alignItems="center"
      >
        <Button
          href={TRIAL_BOOKING_URL}
          variant="contained"
          size="large"
          sx={{
            bgcolor: "primary.main",
            color: "common.white",
            fontWeight: 900,
            fontSize: { xs: 15, sm: 17 },
            px: { xs: 4, sm: 5 },
            py: { xs: 1.6, sm: 1.8 },
            borderRadius: 2,
            boxShadow: "0 4px 20px rgba(0,0,0,0.3)",
            "&:hover": { bgcolor: "primary.dark" },
          }}
        >
          Book Trial Class - 80 DKK
        </Button>
        <Button
          variant="outlined"
          size="large"
          onClick={() => {
            document
              .getElementById("aboutus")
              ?.scrollIntoView({ behavior: "smooth" });
          }}
          sx={{
            borderColor: "common.white",
            color: "common.white",
            fontWeight: 700,
            fontSize: { xs: 15, sm: 17 },
            px: { xs: 4, sm: 5 },
            py: { xs: 1.6, sm: 1.8 },
            borderRadius: 2,
            "&:hover": {
              borderColor: "common.white",
              bgcolor: "rgba(255,255,255,0.1)",
            },
          }}
        >
          Learn more
        </Button>
      </Stack>
    </Box>
  </Box>
);
